/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: cGVJnrZBpZGCmuty7FxDYj
// Component: bGrmdU-Pxw93
import * as React from "react";
import {
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import PageLayout from "../../PageLayout"; // plasmic-import: uyj0PXLvMOqU/component
import Container from "../../Container"; // plasmic-import: D1maE2RgYRQ-/component
import Disclaimer from "../../Disclaimer"; // plasmic-import: 3Ntynz3mbk3J/component
import Footer from "../../Footer"; // plasmic-import: -uu8Ke8fb9WQ/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/projectcss
import sty from "./PlasmicCause.module.css"; // plasmic-import: bGrmdU-Pxw93/css

const emptyProxy = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q) {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export function generateDynamicMetadata($q, $ctx) {
  return {
    openGraph: {},
    twitter: {
      card: "summary"
    }
  };
}

createPlasmicElementProxy;

export const PlasmicCause__VariantProps = new Array();

export const PlasmicCause__ArgProps = new Array("onClick2");

const $$ = {};

function PlasmicCause__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = _useGlobalVariants();
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div className={"plasmic_page_wrapper"}>
        <div
          data-plasmic-name={"pageHome"}
          data-plasmic-override={overrides.pageHome}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            "all",
            "root_reset_cGVJnrZBpZGCmuty7FxDYj",
            "plasmic_default_styles",
            "plasmic_mixins",
            styleTokensClassNames,
            sty.pageHome
          )}
        >
          <div
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("all", sty.sidebar)}
          >
            <div className={classNames("all", "__wab_text", sty.text__yQoDq)}>
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link___3Lpth
                    )}
                    href={"https://o21p.com/"}
                    platform={"react"}
                  >
                    {"o21p"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" | "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link__kei7G
                    )}
                    href={`/old-homepage`}
                    platform={"react"}
                  >
                    {"team"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div className={classNames("all", "__wab_text", sty.text__uULjn)}>
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link__mffhV
                    )}
                    href={`/cause`}
                    platform={"react"}
                  >
                    {"cause"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div className={classNames("all", "__wab_text", sty.text__bx9F)}>
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link__mQsJ7
                    )}
                    href={`/the-system-we-build-ourselves`}
                    platform={"react"}
                  >
                    {"our worldview"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div className={classNames("all", "__wab_text", sty.text__gfPdo)}>
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link__yyORd
                    )}
                    href={`/the-independent`}
                    platform={"react"}
                  >
                    {"the independent"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
          </div>
          <PageLayout
            data-plasmic-name={"pageLayout"}
            data-plasmic-override={overrides.pageLayout}
            className={classNames("__wab_instance", sty.pageLayout)}
            content={
              <React.Fragment>
                <section
                  data-plasmic-name={"s00"}
                  data-plasmic-override={overrides.s00}
                  className={classNames("all", sty.s00)}
                >
                  <Container
                    className={classNames(
                      "__wab_instance",
                      sty.container___9Rp4B
                    )}
                    colContent={
                      <div className={classNames("all", sty.freeBox__dk8Vo)}>
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__dpc2J
                          )}
                        >
                          {
                            "we imagine a world in which the individual lives and works on their own terms, preserving their autonomy and identity within increasingly complex systems."
                          }
                        </div>
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__gantR
                          )}
                        >
                          {
                            "in a world obsessed with optimizing everything and everyone, we choose to empower the unrepeatable self. we stand with those who still think, feel, and choose for themselves. these are the truths we work from, the future we\u2019re building toward, and the values we refuse to compromise."
                          }
                        </div>
                      </div>
                    }
                    width={"large"}
                  />
                </section>
                <section
                  data-plasmic-name={"s999"}
                  data-plasmic-override={overrides.s999}
                  className={classNames("all", sty.s999)}
                >
                  <Disclaimer
                    data-plasmic-name={"disclaimer"}
                    data-plasmic-override={overrides.disclaimer}
                    className={classNames("__wab_instance", sty.disclaimer)}
                  />

                  <Footer
                    data-plasmic-name={"footer"}
                    data-plasmic-override={overrides.footer}
                    className={classNames("__wab_instance", sty.footer)}
                    layout={"withOffset"}
                    sectionId={"footer"}
                  />
                </section>
                <section
                  data-plasmic-name={"s1"}
                  data-plasmic-override={overrides.s1}
                  className={classNames("all", sty.s1)}
                >
                  <Container
                    className={classNames(
                      "__wab_instance",
                      sty.container__r8Qc
                    )}
                    colContent={
                      <div className={classNames("all", sty.freeBox__o6Bd0)}>
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__cGVJn",
                            "__wab_text",
                            sty.p__mk6Ls
                          )}
                        >
                          {"paragraph"}
                        </p>
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__cGVJn",
                            "__wab_text",
                            sty.p___34V8
                          )}
                        >
                          {"paragraph"}
                        </p>
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__cGVJn",
                            "__wab_text",
                            sty.p__vRldn
                          )}
                        >
                          {"paragraph"}
                        </p>
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__cGVJn",
                            "__wab_text",
                            sty.p__kUvI
                          )}
                        >
                          {"paragraph"}
                        </p>
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__cGVJn",
                            "__wab_text",
                            sty.p__wqcn8
                          )}
                        >
                          {"paragraph"}
                        </p>
                      </div>
                    }
                  />
                </section>
              </React.Fragment>
            }
            layoutSections={"withNav"}
          />

          <div
            data-plasmic-name={"noBudgetSmallScreens"}
            data-plasmic-override={overrides.noBudgetSmallScreens}
            className={classNames("all", sty.noBudgetSmallScreens)}
          >
            <div className={classNames("all", "__wab_text", sty.text__rx1Ub)}>
              {"o21p"}
            </div>
            <div className={classNames("all", "__wab_text", sty.text__cy51E)}>
              {
                "our massive development budget is dedicated to designing and building the platform for larger screens."
              }
            </div>
            <div className={classNames("all", "__wab_text", sty.text___4G3UA)}>
              {"\u2013 at least 900px wide \u2013"}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  pageHome: [
    "pageHome",
    "sidebar",
    "pageLayout",
    "s00",
    "s999",
    "disclaimer",
    "footer",
    "s1",
    "noBudgetSmallScreens"
  ],

  sidebar: ["sidebar"],
  pageLayout: ["pageLayout", "s00", "s999", "disclaimer", "footer", "s1"],
  s00: ["s00"],
  s999: ["s999", "disclaimer", "footer"],
  disclaimer: ["disclaimer"],
  footer: ["footer"],
  s1: ["s1"],
  noBudgetSmallScreens: ["noBudgetSmallScreens"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCause__ArgProps,
          internalVariantPropNames: PlasmicCause__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCause__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "pageHome") {
    func.displayName = "PlasmicCause";
  } else {
    func.displayName = `PlasmicCause.${nodeName}`;
  }
  return func;
}

export const PlasmicCause = Object.assign(
  // Top-level PlasmicCause renders the root element
  makeNodeComponent("pageHome"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    pageLayout: makeNodeComponent("pageLayout"),
    s00: makeNodeComponent("s00"),
    s999: makeNodeComponent("s999"),
    disclaimer: makeNodeComponent("disclaimer"),
    footer: makeNodeComponent("footer"),
    s1: makeNodeComponent("s1"),
    noBudgetSmallScreens: makeNodeComponent("noBudgetSmallScreens"),
    // Metadata about props expected for PlasmicCause
    internalVariantProps: PlasmicCause__VariantProps,
    internalArgProps: PlasmicCause__ArgProps,
    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/cause",
      pagePath: "/cause",
      params: {},
      query: {}
    })
  }
);

export default PlasmicCause;
/* prettier-ignore-end */
